import { render } from "./service-promise.vue?vue&type=template&id=21f69476&scoped=true"
import script from "./service-promise.vue?vue&type=script&lang=js"
export * from "./service-promise.vue?vue&type=script&lang=js"

import "./service-promise.vue?vue&type=style&index=0&id=21f69476&lang=scss&scoped=true"

import exportComponent from "/www/publicHouse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21f69476"]])

export default __exports__